import { usdFormatter } from "../../../../functions/currency";

export function formatCurrency(value: number | undefined) {
  return value ? usdFormatter.format(value) : "--";
}
